import { BLOCK_TYPES } from "../../common/index";
const { PHONE_BLOCK } = BLOCK_TYPES;

const PHONE_DEFAULT_VALUE = {
    type: PHONE_BLOCK,
    data: {
        text: [],
        description: [],
        isRequired: false,
        countryCode: "91",
        jumpTo: {
            default: null,
            conditions: [],
        },
    },
};

export default PHONE_DEFAULT_VALUE;
